import { emailValidate } from '@utils/global-functions';
import '../../style/templates/customers.scss';
import '../../style/templates/order.scss';
import RewardsTableSlider from '@modules/rewardsTableSlider';

document.addEventListener('DOMContentLoaded', () => {
  // Login Page
  if (window.location.pathname == '/account/login') {
    // Validate Email Login
    document.querySelector('.customer__login-button').addEventListener('click', (event) => {
      event.preventDefault();
      const emailInput = document.querySelector('#CustomerEmail');
      const validated = emailValidate(emailInput);
      const form = document.getElementById('customer_login');
      if (validated == 'true') form.submit();
    });

    // Recover Email Success Message
    if (!!document.querySelector('.message__success')) {
      document.querySelector('#recover').classList.add('success');
      document.querySelector('.recover__cancel.button').addEventListener('click', () => {
        document.querySelector('#recover').classList.toggle('success');
      });
    }
    if (document.referrer.indexOf('/account/register') > 0) {
      const accountErrorMsg = `<p class="customer__login-error p5" data-color="magic-hour-error">${document.querySelector('.customer__login').getAttribute('data-error-msg')}</p>`;
      document.querySelector('.customer__login-register-link').insertAdjacentHTML('afterend', accountErrorMsg);
    }
  }

  // Account Page
  if (window.location.pathname == '/account') {
    // Active States of Account Links
    const { hash } = window.location;
    if (hash !== '#confirmation') {
      // Order History as default
      if (hash == '' || (hash !== '#brooklinen-rewards' && hash !== '#account-details' && hash !== '#order-history')) window.location.hash = '#order-history';
      else {
        // Set tabs on account page links
        document.querySelector('.customer__link.active').classList.remove('active');
        document.querySelector('.customer__info.active').classList.remove('active');
        document.querySelector(`a[href="${window.location.hash}"]`).classList.add('active');
        if (document.querySelector(`${window.location.hash}`)) document.querySelector(`${window.location.hash}`).classList.add('active');
      }
      // Toggle Customer Info Content
      Array.from(document.querySelectorAll('.customer__link')).forEach((link) => {
        link.addEventListener('click', (event) => {
          document.querySelector('.customer__link.active').classList.remove('active');
          document.querySelector('.customer__info.active').classList.remove('active');
          event.target.classList.add('active');
          if (document.querySelector(`${event.target.getAttribute('href')}`)) document.querySelector(`${event.target.getAttribute('href')}`).classList.add('active');
        });
      });
    } else {
      // Confirmation page for newly signed up
      document.querySelector('.customer.account').classList.add('hidden');
      document.querySelector('.customer.confirmation').classList.remove('hidden');
      if (document.querySelector('.js-product-slider')) document.querySelector('.js-product-slider').classList.remove('hidden');
    }

    // Customer Rewards
    if (document.querySelector('#brooklinen-rewards')) {
      setTimeout(() => {
        const email = document.querySelector('[data-customer]')?.dataset.customer;
        const customerCurrentPoints = window.Brooklinen.loyalty?.points_balance;
        const customerTier = window.Brooklinen.loyalty?.vip_tier_name;
        if (email && customerCurrentPoints >= 0) {
          Array.from(document.querySelectorAll('.swell-point-balance')).forEach((el) => {
            el.innerHTML = customerCurrentPoints;
          });
          if (customerTier) document.querySelector('.swell-member').innerHTML = customerTier;
        } else {
          document.querySelector('.swell-text').innerHTML = 'Sorry! We are unable to load your rewards status. Please refresh the page.';
        }
        document.querySelector('.swell-text').classList.add('loaded');
      }, 2000);

      document.querySelector('.redeem-now-button').addEventListener('click', () => {
        const element = document.querySelector('#redeemNow');
        setTimeout(
          () =>
            element.scrollIntoView({
              block: 'start',
              behavior: 'smooth',
            }),
          400
        );
      });
    }
  }

  // Account and Addresses Page
  if (window.location.pathname == '/account' || window.location.pathname == '/account/addresses') {
    // Add Province options to Select element
    Array.from(document.querySelectorAll('.address-form')).forEach((el) => {
      const newId = el.id.replace('address', '');
      const newSelector = new Shopify.CountryProvinceSelector(`Address_Country_${newId}`, `Address_Province_${newId}`, {});
      newSelector.provinceEl.style.display = 'block';
    });

    // Delete Address
    Array.from(document.querySelectorAll('.delete-address-trigger')).forEach((link) => {
      link.addEventListener('click', (event) => {
        const { addressId } = link.dataset;
        if (confirm('Are you sure you wish to delete this address?')) {
          Shopify.postLink(`/account/addresses/${addressId}`, {
            parameters: { _method: 'delete' },
          });
        }
      });
    });

    // Edit Address
    Array.from(document.querySelectorAll('.edit-address-trigger')).forEach((link) => {
      link.addEventListener('click', (event) => {
        const { addressId } = link.dataset;
        if (document.querySelector('.address-form.active')) document.querySelector('.address-form.active').classList.remove('active');
        document.querySelector(`#address${addressId}`).classList.add('active');
      });
    });

    // Set As Default Logic
    Array.from(document.querySelectorAll('.assign-default-link')).forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        link.classList.toggle('active');
        link.nextElementSibling.checked = !link.nextElementSibling.checked;
      });
    });

    if (window.innerHeight > 800) document.querySelector('.account__address-forms .overlay__modal--content').classList.add('modal--lrg');
  }

  if (document.querySelector('.section-account.hidden')) document.querySelector('.section-account.hidden').classList.remove('hidden');

  // Rewards Tier Table Slider
  const tierSliders = document.querySelectorAll('.tier-compare-mobile');
  if (tierSliders.length > 0) Array.from(tierSliders).forEach((tierSlider) => new RewardsTableSlider(tierSlider));
});
